import ThemeProvider from '@tracsis/library/src/context/ThemeContext';
import cx from 'classnames';
import React from 'react';

import { CookieConsentPopup, Footer, Header } from '../../../index';
import AltFooter from '../Footer/AltFooter';
import MinimalFooter from '../Footer/MinimalFooter';

export interface IGlobalNavigationItem {
	label: string;
	to: string;
	header?: boolean;
	menu: any;
}

export interface INavigationItem {
	label: string;
	to?: string;
	header?: boolean;
	hilite?: boolean;
	description?: string;
	links?: INavigationLink[];
	subMenu?: INavigationLink[];
	globalNavigation?: IGlobalNavigationItem[];
}

export interface INavigationLink {
	label: string;
	to?: string;
	header?: boolean;
	description?: string;
	subMenu?: INavigationLink[];
}

export interface ISocialLink {
	platform: string;
	to?: string;
}

export interface IInnotransNavLink {
	label: string;
	to?: string;
	header?: boolean;
	description?: string;
	links?: INavigationLink[];
	subMenu?: INavigationLink[];
}

const Layout = ({
	siteName,
	logo,
	navigation,
	careers = true,
	subNavigation,
	mobileSubNavigation,
	innotransnav,
	social,
	iso,
	isGroup = false,
	variant = 'standard',
	height,
	footer = 'standard',
	footerContent,
	footerNav1,
	footerNav2,
	footerNav3,
	footerNav4,
	footerNav5,
	children,
	className = '',
	hiliteNavItem,
	isCampaign = false,
}: {
	siteName: string;
	logo: React.ReactNode;
	navigation: INavigationItem[];
	innotransnav?: IInnotransNavLink[];
	careers?: boolean;
	subNavigation: INavigationLink[];
	mobileSubNavigation?: any;
	social?: ISocialLink[];
	iso?: {
		link: string;
		text: string;
		logo?: string;
	}[];
	isGroup?: boolean;
	variant?: 'standard' | 'altaccent';
	height?: any;
	footer?: 'standard' | 'altfooter' | 'minimal';
	footerContent?: React.ReactNode;
	footerNav1?: INavigationLink[];
	footerNav2?: INavigationLink[];
	footerNav3?: INavigationLink[];
	footerNav4?: INavigationLink[];
	footerNav5?: INavigationLink[];
	children: React.ReactNode;
	className?: string;
	hiliteNavItem?: string;
	isCampaign?: boolean;
}) => {
	return (
		<ThemeProvider variant={variant}>
			<div id="skiptocontent" className="visuallyhidden">
				<a href="#main">skip to main content</a>
			</div>
			<div
				id="site-container"
				className={cx('site-container', className)}
				role="document">
				<div id="top"></div>
				<Header
					siteName={siteName}
					logo={logo}
					navigation={navigation}
					subNavigation={mobileSubNavigation}
					innotransnav={innotransnav}
					careers={careers}
					isGroup={isGroup}
					isCampaign={isCampaign}
				/>
				<main>
					{children}
					<CookieConsentPopup />
				</main>

				{footer === 'altfooter' ? (
					<AltFooter
						logo={logo}
						navigation={navigation}
						subNavigation={subNavigation}
						social={social}
						isGroup={isGroup}
						footerNav1={footerNav1}
						footerNav2={footerNav2}
						footerNav3={footerNav3}
						footerNav4={footerNav4}
						footerNav5={footerNav5}
						iso={iso}
					/>
				) : footer === 'minimal' ? (
					<MinimalFooter
						logo={logo}
						social={social}
						isGroup={isGroup}
						footerContent={footerContent}
					/>
				) : (
					<Footer
						logo={logo}
						navigation={navigation}
						subNavigation={subNavigation}
						social={social}
						isGroup={isGroup}
						iso={iso}
					/>
				)}
			</div>
		</ThemeProvider>
	);
};

export default Layout;
